'use client';

import { useRef } from 'react';
import { useTranslations } from 'next-intl';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import { BackgroundVideo } from 'components/landing/BackgroundVideo';
import {
  FilmWatchButton,
  useFilmVideoModal,
} from 'components/landing/v3/FilmVideoModal';
import { useTextReveal } from './hooks/useTextReveal';
import styles from './Craft.module.css';

/* The homepage EmeraldArcSection's film card and watch pill, without its store
   pills, playing the lab footage. One 16:9 cut serves every size. */
const VIDEO_SRC = getCompressedAssetUrl(
  '/web_v2/why-ultrahuman/build-assets.mp4',
);

export const Craft = () => {
  const t = useTranslations('whyUltrahuman');
  const sectionRef = useRef<HTMLElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const openVideoModal = useFilmVideoModal(videoRef, { desktop: VIDEO_SRC });
  useTextReveal(sectionRef);

  return (
    <section
      ref={sectionRef}
      className={styles.outer}
      aria-labelledby="why-ultrahuman-craft-title"
    >
      <div className={styles.stage}>
        <div className={styles.intro}>
          <h2
            id="why-ultrahuman-craft-title"
            className={styles.title}
            data-reveal
          >
            {t('craft.title')}
          </h2>
          <p className={styles.body} data-reveal>
            {t('craft.body')}
          </p>
        </div>
        <div className={styles.filmLayer} data-reveal>
          <div className={styles.filmCard} aria-label={t('craft.videoLabel')}>
            <div className={styles.filmVideoFill}>
              {/* Below the fold: `autoplay` would override `preload` and fetch the
                  film on load; BackgroundVideo plays it once it scrolls in. */}
              <BackgroundVideo
                ref={videoRef}
                src={VIDEO_SRC}
                autoPlay={false}
                preload="none"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
            <FilmWatchButton
              onClick={openVideoModal}
              buttonType="why-uh craft watch"
              label={t('craft.watch')}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
